// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as BillingAccount from "../../modules/Billing/BillingAccount.res.js";
import * as SettingsRoutes from "./SettingsRoutes.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as SettingsUserPage from "./SettingsUserPage.res.js";
import * as SettingsShopsPage from "./SettingsShopsPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SettingsLabelPrinterPage from "./SettingsLabelPrinterPage.res.js";
import * as SettingsBillingAccountShowPage from "./SettingsBillingAccountShowPage.res.js";
import * as SettingsElectronicInvoicingPage from "./SettingsElectronicInvoicingPage.res.js";
import * as SettingsBillingAccountListInvoicesPage from "./SettingsBillingAccountListInvoicesPage.res.js";

function SettingsRouter(props) {
  let subUrlPath = props.subUrlPath;
  let userRole = Auth.useRole();
  let scope = Auth.useScope();
  let shop;
  if (scope.TAG === "Organisation") {
    let shop$1 = scope.activeShop;
    shop = shop$1 !== undefined ? shop$1 : scope.shops[0];
  } else {
    shop = scope._0;
  }
  if (!Auth.isAuthorizedAccess(userRole, SettingsRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  let exit = 0;
  if (subUrlPath !== 0) {
    switch (subUrlPath.hd) {
      case "billing-account" :
        let match = subUrlPath.tl;
        if (match !== 0) {
          let shopId = match.hd;
          let match$1 = match.tl;
          if (match$1 !== 0) {
            if (match$1.hd === "invoices") {
              if (match$1.tl === 0) {
                return JsxRuntime.jsx(SettingsBillingAccountListInvoicesPage.make, {
                  shopId: shopId,
                  invoicesRequest: BillingAccount.invoicesRequest
                });
              }
              exit = 1;
            } else {
              exit = 1;
            }
          } else {
            switch (shopId) {
              case "edit" :
                exit = 2;
                break;
              case "payment-failed" :
                return JsxRuntime.jsx(SettingsBillingAccountShowPage.make, {
                  shopId: shop.id,
                  invoicesRequest: BillingAccount.invoicesRequest,
                  subscriptionsRequest: SettingsBillingAccountShowPage.subscriptionsRequest,
                  notification: {
                    TAG: "Danger",
                    _0: I18n.t("We were unable to complete your payment due to a technical error. Please try again or contact us for assistance.")
                  }
                });
              case "payment-succeeded" :
                return JsxRuntime.jsx(SettingsBillingAccountShowPage.make, {
                  shopId: shop.id,
                  invoicesRequest: BillingAccount.invoicesRequest,
                  subscriptionsRequest: SettingsBillingAccountShowPage.subscriptionsRequest,
                  notification: {
                    TAG: "Success",
                    _0: I18n.t("Your payment has been successfully processed. You can now fully enjoy our services.")
                  }
                });
              default:
                return JsxRuntime.jsx(SettingsBillingAccountShowPage.make, {
                  shopId: shopId,
                  invoicesRequest: BillingAccount.invoicesRequest,
                  subscriptionsRequest: SettingsBillingAccountShowPage.subscriptionsRequest
                });
            }
          }
        } else {
          exit = 2;
        }
        break;
      case "electronic-invoicing" :
        let match$2 = subUrlPath.tl;
        if (match$2 === 0) {
          return JsxRuntime.jsx(SettingsElectronicInvoicingPage.make, {});
        }
        if (match$2.hd === "setup") {
          if (match$2.tl === 0) {
            return JsxRuntime.jsx(SettingsElectronicInvoicingPage.make, {
              setupRedirected: true
            });
          }
          exit = 1;
        } else {
          exit = 1;
        }
        break;
      case "label-printer" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(SettingsLabelPrinterPage.make, {});
        }
        exit = 1;
        break;
      case "shops" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(SettingsShopsPage.make, {
            updateShopRequest: SettingsShopsPage.UpdateShopRequest.make
          });
        }
        exit = 1;
        break;
      case "user" :
        if (subUrlPath.tl === 0) {
          return JsxRuntime.jsx(SettingsUserPage.make, {
            updateEmailRequest: SettingsUserPage.updateEmailRequest,
            updatePasswordRequest: SettingsUserPage.updatePasswordRequest,
            updateUserNamesRequest: SettingsUserPage.updateUserNamesRequest
          });
        }
        exit = 1;
        break;
      default:
        exit = 1;
    }
  } else {
    exit = 1;
  }
  switch (exit) {
    case 1 :
      return JsxRuntime.jsx(Navigation.Redirect.make, {
        route: props.appIndexRoute
      });
    case 2 :
      return JsxRuntime.jsx(Navigation.Redirect.make, {
        route: SettingsRoutes.billingAccountShowRoute(shop.id, undefined)
      });
  }
}

let invoicesRequest = BillingAccount.invoicesRequest;

let make = SettingsRouter;

export {
  invoicesRequest,
  make,
}
/* Auth Not a pure module */
